/**
 * Formate le nom affiché dans l'app : « Prénom P. » (prénom complet + initiale
 * du nom). Objectif : limiter la PII visible (classements, profil, réglages).
 *
 * - nom vide → prénom seul (« Sven »)
 * - prénom vide → chaîne vide : c'est au code appelant d'appliquer son
 *   fallback existant (« Utilisateur », CTA « Ajoute ton prénom », etc.)
 * - l'initiale est prise via [...str][0] pour rester correcte sur les
 *   caractères hors BMP (émojis, etc.) et conserver les accents (« Édouard »
 *   → « É. »)
 * - idempotent : si le nom est déjà une initiale (« M. »), le résultat reste
 *   « Prénom M. » — utile car les RPC de classement renvoient désormais
 *   l'initiale côté serveur.
 */
export function formatDisplayName(
  firstName?: string | null,
  lastName?: string | null,
): string {
  const first = (firstName ?? "").trim();
  if (!first) return "";

  const last = (lastName ?? "").trim();
  if (!last) return first;

  const initial = [...last][0].toLocaleUpperCase("fr-CH");
  return `${first} ${initial}.`;
}
